module.exports = __webpack_public_path__ + "img/train_cover.94a449cc.jpg";